// src/components/BreadcrumbNav.js
import React, { useContext } from 'react';
import { PathContext } from '../contexts/PathContext';

export default function BreadcrumbNav() {
  const { path, setPath: onNavigate } = useContext(PathContext);

  // Split path into segments, filter empty strings to avoid extra crumbs
  const segments = path ? path.split('/').filter(Boolean) : [];

  // Build crumbs array including Home as root
  const crumbs = [{ name: 'Home', fullPath: '' }].concat(
    segments.map((seg, idx) => ({
      name: seg,
      fullPath: segments.slice(0, idx + 1).join('/'),
    }))
  );

  return (
    <nav
      aria-label="Breadcrumb"
      style={{
        fontSize: '0.9rem',
        color: '#6b7280',
        backgroundColor: '#f9fafb',
        padding: '8px 16px',
        borderRadius: 6,
        boxShadow: '0 1px 3px rgb(0 0 0 / 0.1)',
        userSelect: 'none',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 4,
        marginBottom: 20,
      }}
    >
      {crumbs.map(({ name, fullPath }, idx) => {
        const isLast = idx === crumbs.length - 1;

        return (
          <React.Fragment key={fullPath || 'home'}>
            <button
              onClick={() => !isLast && onNavigate(fullPath)}
              disabled={isLast}
              aria-current={isLast ? 'page' : undefined}
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                margin: 0,
                fontWeight: isLast ? '700' : '500',
                color: isLast ? '#111827' : '#2563eb',
                cursor: isLast ? 'default' : 'pointer',
                userSelect: 'none',
                fontSize: '1rem',
                transition: 'color 0.2s',
                textDecoration: isLast ? 'none' : 'underline',
                display: 'inline-flex',
                alignItems: 'center',
              }}
              onMouseEnter={e => {
                if (!isLast) e.currentTarget.style.color = '#1d4ed8';
              }}
              onMouseLeave={e => {
                if (!isLast) e.currentTarget.style.color = '#2563eb';
              }}
            >
              {name}
            </button>

            {!isLast && (
              <span
                aria-hidden="true"
                style={{
                  margin: '0 8px',
                  color: '#9ca3af',
                  userSelect: 'none',
                  fontWeight: '600',
                }}
              >
                ›
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}